export function getMissingExternalAttendeeProfileFields(user = {}, privateProfile = {}, preset = 'basic') {
  const displayName = [user.firstName, user.lastName].filter(value => String(value || '').trim()).join(' ').trim()
    || String(user.username || '').trim();
  const missing = [];
  if (!displayName) missing.push({ key: 'name', label: 'name', tab: 'profile' });
  if (!String(privateProfile.phone || '').trim()) missing.push({ key: 'phone', label: 'contact phone', tab: 'profile' });
  if (preset === 'safety') {
    const dobText = String(privateProfile.dob || '').trim();
    const dob = /^\d{4}-\d{2}-\d{2}$/.test(dobText) ? new Date(`${dobText}T00:00:00Z`) : null;
    if (!dob || Number.isNaN(dob.getTime()) || dob > new Date()) {
      missing.push({ key: 'dob', label: 'date of birth', tab: 'profile' });
    }
    const hasEmergencyContact = Array.isArray(privateProfile.emergencyContacts)
      && privateProfile.emergencyContacts.some(contact => (
        String(contact?.name || '').trim()
        && String(contact?.relationship || '').trim()
        && String(contact?.phone || '').trim()
      ));
    if (!hasEmergencyContact) missing.push({ key: 'emergency', label: 'emergency contact', tab: 'emergency' });
  }
  return missing;
}

export function safeInternalReturnPath(rawPath, fallback = '') {
  if (typeof rawPath !== 'string' || !rawPath.startsWith('/') || rawPath.startsWith('//')) return fallback;
  return rawPath;
}
